import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const clearKittyLinkedContributionError = () => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.KITTY_LINKED_CONTRIBUTION_HTTP_ERROR,
      payload: {
        clear: true
      }
    });
  };
};

export const addKittyLinkedContribution = (_id: string, contribution_id: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.KITTY_LINKED_CONTRIBUTION_HTTP_LOADING
    });

    request({ method: "post", pathname: "addKittyLinkedContribution", data: { _id, contribution_id } })
      .then((response) => {
        dispatch({
          type: actions.KITTY_LINKED_CONTRIBUTION_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.KITTY_LINKED_CONTRIBUTION_HTTP_ERROR, error, dispatch);
      });
  };
};

export const deleteKittyLinkedContribution = (_id: string, contribution_id: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.KITTY_LINKED_CONTRIBUTION_HTTP_LOADING
    });

    request({ method: "post", pathname: "deleteKittyLinkedContribution", data: { _id, contribution_id } })
      .then((response) => {
        dispatch({
          type: actions.KITTY_LINKED_CONTRIBUTION_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.KITTY_LINKED_CONTRIBUTION_HTTP_ERROR, error, dispatch);
      });
  };
};
